import { BrowserRouter } from 'react-router'
import type { SedeConfig } from '../../sedi/types'
import { SiteRoutes } from './SiteRoutes'
import './styles/vc2.css'

/**
 * Browser entry for the Verde Vercelli 2 site. The prerender mounts
 * `SiteRoutes` directly under a StaticRouter, so keep everything that
 * needs a window (the BrowserRouter) on this side of the boundary.
 */
export function VerdeVercelli2App({ sede }: { sede: SedeConfig }) {
  return (
    <BrowserRouter>
      <SiteRoutes sede={sede} />
    </BrowserRouter>
  )
}
